export const columns = [
  {
    key: "count",
    header: "S.",
    isSortable: false,
    className: "count",
  },
  {
    key: "name",
    header: "FSC Location",
    isSortable: true,
    className: "dark",
  },
  {
    key: "price",
    header: "Price Per Gallon",
    isSortable: false,
    className: "",
  },
];

export type FscLocationData = {
  id?: string;
  name: string;
  price: string | number | null;
};

export type AddEditFscLocationModalProps = {
  isEdit: boolean;
  isOpen: boolean;
  onClose: () => void;
  initialData?: FscLocationData | null;
  onSuccess?: () => void;
};
